<template>
  <div>
    <div>
      <div class="flex-x-y-center">
        <div class="profile-content">
          <div v-show="process.content.goods_pay_swtich === 0">
            <div class="iconfont icon-jinhangzhong flex-x-y-center advisement-icon"></div>
            <div class="title flex-x-y-center">待选购</div>
          </div>
          <div v-show="process.content.goods_pay_swtich === 1">
            <div class="iconfont icon-tongguo flex-x-y-center pass-icon"></div>
            <div class="title flex-x-y-center">
              已购买，书籍将尽快邮寄。如还需购买其他书，请进入“书籍订购”购买。
            </div>
          </div>
          <div class="inner-box">
            <div class="title">相关教材</div>
            <div class="sill"></div>
            <el-table style="width: 100%" :data="process.content.goods_list">
              <el-table-column prop="title" label="名称"></el-table-column>
              <el-table-column prop="price" label="价格"> </el-table-column>
              <el-table-column label="加入购物车">
                <template slot-scope="scope">
                  <el-checkbox :disabled="scope.row.is_must === 1" :checked="scope.row.is_must === 1 || scope.row.isCheck === 1
                    " v-model="scope.row.isCheck"></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="redress-box" v-show="process.content.goods_pay_swtich === 0">
            <div class="input-receive">请填写收货地址</div>
            <div class="flex">
              <span class="redress-name flex-y-center"><span style="padding: 3px; margin-top: 4px; color: red">*
                </span>姓名：</span><input class="redress-input" type="text" placeholder="请输入收货人姓名"
                v-model="ship_username" />
            </div>
            <div class="flex">
              <span class="redress-name flex-y-center"><span style="padding: 3px; margin-top: 4px; color: red">*
                </span>
                电话：</span><input class="redress-input" type="text" placeholder="请输入收货人电话" v-model="ship_mobile" />
            </div>

            <div class="flex">
              <span class="redress-name flex-y-center"><span style="padding: 3px; margin-top: 4px; color: red">*
                </span>收货地址：</span><input class="redress-input" type="text" placeholder="请输入收货地址"
                v-model="ship_address" />
            </div>
          </div>
        </div>
      </div>
      <div v-show="process.enable == 1 && process.content.goods_pay_swtich === 0" class="flex-x-center agree-sign-next">
        <button class="next-step" @click="selectAll">全选</button>
        <button class="next-step-pay" @click="goPayBook">
          确认收货地址并支付
        </button>
        <button class="next-step-pay" @click="$parent.next()">
          跳过进入下一步
        </button>
      </div>
      <div v-show="process.enable == 1 && process.content.goods_pay_swtich === 1" class="flex-x-center agree-sign-next">
        <button class="next-step" @click="$parent.next()">下一步</button>
      </div>
    </div>
    <el-dialog title="是否已完成支付" :visible.sync="xgjcVisiblePay" width="30%">
      <span>请在请打开的页面中完成支付</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xgjcVisiblePay = false">取消支付</el-button>
        <el-button type="primary" @click="checkPayResult()">已完成支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { erroralert, successalert } from "@/utils/alert";
import {
  reqProjectSavedata,
  reqProjectDetail,
  reqCreateGoodsOrder,
} from "@/api";
export default {
  data() {
    return {
      xgjcVisiblePay: false,
      name: "",
      goods_ids: [],
      ship_username: "",
      ship_mobile: "",
      ship_address: "",
    };
  },
  props: {
    // 流程
    process_index: 0,
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  methods: {
    ...mapActions(useMainStore, {
      changeProject: "updateProjectDetail",
    }),
    checkPayResult() {
      this.xgjcVisiblePay = false;
      this.$parent.reload();
    },
    selectAll() { },
    goPayBook() {
      //清空goods_ids
      this.goods_ids = [];
      for (let book of this.process.content.goods_list) {
        if (book.isCheck) {
          this.goods_ids.push(book.id);
        }
      }
      //_.uniq()
      console.log(this.goods_ids.toString());
      //保存入库

      reqCreateGoodsOrder({
        goods_ids: this.goods_ids,
        ship_username: this.ship_username,
        ship_mobile: this.ship_mobile,
        ship_address: this.ship_address,
        project_id: this.$parent.projectDetail.project_info.id,
      }).then((res) => {
        if (res.data.code === 1) {
          window.open(res.data.data.pay_url);
          this.xgjcVisiblePay = true;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    next() {
      let that = this;
      if (that.active < 10) {
        that.active++;
        console.log(that.active);
      } else {
        that.active = 0;
      }
    },
  },
  computed: {
    ...mapState(useMainStore, {
      projectDetail: "getProjectDetail",
    }),
  },
  mounted() { },
};
</script>

<style>
.next-step-pay:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.confirm-redress-button {
  padding: 5px;
  margin: 10px;
  border: rgb(191, 186, 186) 1pxsolid;
}

.input-receive {
  font-size: 14px;
  padding-left: 10px;
  padding-top: 20px;
  font-weight: 400;
}

.redress-box {
  margin-top: 20px;
  width: 96%;
  margin-left: 2%;
}

.redress-name {
  width: 100px;
  margin-top: 10px;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 350;
}

.redress-input {
  border: rgb(239, 235, 235) 1px solid;
  width: 100%;
  height: 35px;
  margin-top: 10px;
  border-radius: 4px;
  padding-left: 10px;
}

.item-text {
  font-size: 16px;
  margin: 20px 10%;
  color: rgb(56, 55, 55);
}

.next-step-pay {
  color: #b8000d;
  border: #b8000d 1px solid;

  height: 30px;
  box-sizing: content-box;
  padding: 2px 5px;
  border-radius: 3px;
  margin-left: 30px;
  background-color: white;
  margin-top: 5px;
  /* margin-left: 30px;
  height: 30px;
  margin-top: 5px;
  border: #b8000d 1px solid;
  color: #b8000d;
  background-color: white;
  padding: 2px;
  border-radius: 3px;
  border-sizing:content-box;
  padding:2px; */
}

.unpassd-icono {
  font-size: 60px;
  color: #b8000d;
}

.advisement-icon {
  font-size: 60px;
  color: rgb(37, 110, 206);
}

.pass-icon {
  font-size: 60px;
  color: rgb(50, 187, 62);
}

.inner-box {
  margin-top: 30px;
}

.title {
  margin-top: 10px;
  padding-top: 0px;
}
</style>
